// extracted by mini-css-extract-plugin
module.exports = {"Tick":"Tick_Tick__2UtCQ","ticked":"Tick_ticked__2owkO"};